import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { getOrCreateActivityAnonKey } from "../config/activityAnonKey";
import { readAffiliateRefForActivity } from "../config/affiliateRef";
import { postActivityLog } from "../services/activityServices";
import { detectDeviceType, readGeoForActivity } from "../utils/deviceDetect";

/**
 * Sends POST /activity/log when the SPA location changes (public client).
 * Fails silently so analytics never blocks navigation.
 */
export default function useActivityLogger() {
  const location = useLocation();
  const mounted = useRef(true);

  useEffect(() => {
    mounted.current = true;
    return () => {
      mounted.current = false;
    };
  }, []);

  useEffect(() => {
    const path = `${location.pathname}${location.search}${location.hash}`.slice(
      0,
      2048
    );
    if (!path) return;

    const anonKey = getOrCreateActivityAnonKey();
    const timer = window.setTimeout(() => {
      if (!mounted.current) return;
      const title =
        typeof document !== "undefined"
          ? String(document.title || "").trim().slice(0, 500)
          : "";
      const affiliateCode = readAffiliateRefForActivity();
      const geo = readGeoForActivity();
      postActivityLog({
        path,
        title,
        referrer: typeof document !== "undefined" ? String(document.referrer || "").slice(0, 2048) : "",
        anonKey,
        affiliateCode: affiliateCode || undefined,
        countryCode: geo.countryCode,
        countryName: geo.countryName,
        deviceType: detectDeviceType(),
        platform: typeof navigator !== "undefined" ? navigator.platform : "",
        browserLanguage: typeof navigator !== "undefined" ? navigator.language : "",
      }).catch(() => {});
    }, 400);

    return () => window.clearTimeout(timer);
  }, [location.pathname, location.search, location.hash]);
}
